import { Link } from 'react-router-dom';

const LogisticsCTA = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-[#1A3A5C] to-[#2A4A6C]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl font-bold text-white mb-6">
          找到适合您的物流与仓储方案
        </h2>
        <p className="text-xl text-white/90 mb-8">
          专业评估，精准匹配，合规保障
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <Link
            to="/test"
            className="w-full sm:w-auto px-8 py-4 bg-[#F7931E] text-white font-bold rounded-full hover:bg-[#F7931E]/90 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            查看我是否适合 1039
          </Link>
          
          <button className="w-full sm:w-auto px-8 py-4 border-2 border-white text-white font-bold rounded-full hover:bg-white hover:text-[#1A3A5C] transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap">
            匹配适合我的物流与仓储方案
          </button>
        </div>

        {/* 埋下的"钩子" */}
        <div className="mt-12 bg-white/5 rounded-lg p-6">
          <p className="text-white/70 text-sm">
            <i className="ri-information-line text-[#F7931E] mr-2"></i>
            部分物流与仓储资源仅对通过 1039 适配评估的客户开放
          </p>
        </div>
      </div>
    </section>
  );
};

export default LogisticsCTA;